import { connect } from 'react-redux'
import MustSpan from './MustSpan'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const MustSpanContainer = connect(
    mapStateToProps,
)(MustSpan)

export default MustSpanContainer
